import * as Yup from 'yup';
import {MacroscopicMediaParam} from '@/contexts/ParamsContext';

export default function createSchema(macroscopicMediaParam: MacroscopicMediaParam) {
  const macroscopicMediaSchema = {
    disabled: Yup.mixed<Blob>().nullable(),
    optional: Yup.mixed<Blob>().nullable(),
    required: Yup.mixed<Blob>().required('ui:form.errors.required')
  };

  return Yup.object({
    images: Yup.array()
      .test('hasFile', 'app:addAtLestOneImage', (value) => value && value?.some((i) => i?.file))
      .required('ui:form.errors.required'),
    bodySiteCode: Yup.string().nullable().required('ui:form.errors.required'),
    extraData: Yup.string().nullable(),
    visitIdentifier: Yup.string().required('ui:form.errors.required'),
    companyCallbackUrl: Yup.string().nullable(),
    lesionType: Yup.string().nullable(),
    macroscopicMedia: macroscopicMediaSchema[macroscopicMediaParam],
    anamnesisQuestions: Yup.mixed<Record<string, string>>().required()
  });
}
